import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import VueMeta from 'vue-meta'
import vuetify from './plugins/vuetify'
Vue.config.productionTip = false

Vue.use(require('vue-moment'));
Vue.use(VueMeta);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
